var _path, _path2, _circle;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.171,
    height: 42.171,
    viewBox: "0 0 42.171 42.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M16.666,5.838a10.82,10.82,0,1,0,10.82,10.82,10.819,10.819,0,0,0-10.82-10.82Zm0,17.843a7.023,7.023,0,1,1,7.023-7.023A7.021,7.021,0,0,1,16.666,23.681Z",
    transform: "translate(4.426 4.419)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M29.78.133C25.9-.048,16.29-.039,12.407.133c-3.412.16-6.422.984-8.849,3.411C-.5,7.6.021,13.064.021,21.078c0,8.2-.457,13.54,3.537,17.534,4.071,4.069,9.615,3.537,17.534,3.537,8.125,0,10.929.005,13.8-1.107,3.906-1.516,6.854-5.008,7.143-11.279.183-3.881.172-13.489,0-17.373C41.689,4.988,37.717.5,29.78.133Zm6.141,35.8c-2.659,2.659-6.347,2.421-14.879,2.421-8.786,0-12.309.13-14.879-2.448C3.2,32.956,3.738,28.224,3.738,21.05c0-9.708-1-16.7,8.747-17.2,2.239-.079,2.9-.105,8.533-.105L21.1,3.8c9.364,0,16.71-.98,17.151,8.761.1,2.223.123,2.89.123,8.517,0,8.684.163,12.228-2.449,14.853Z",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 2.528,
    cy: 2.528,
    r: 2.528,
    transform: "translate(29.813 7.301)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b88e45fa865457ad397844c70d07c60b.svg";
export { ForwardRef as ReactComponent };